import { history } from '../_helpers';
export const marketplaceService = {
  getAllMarketplaces,
  configureMarketplace, // Add the new service function here
  activeCloudStorage,
  getListInfraByMarketplaceId
};

function getAllMarketplaces() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/marketplace`,
    requestOptions
  ).then(handleResponse);
}

function configureMarketplace(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST", // Assuming configuration requires a POST request
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json", // No "Content-Type" for FormData
    },
    body: JSON.stringify(formData), // Send the FormData directly in the request body
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/marketplace/configure`,
    requestOptions
  ).then(handleResponse);
}

function activeCloudStorage(type) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/marketplace/active/cloudStorage/${type}`,
    requestOptions
  ).then(handleResponse);
}

function getListInfraByMarketplaceId(marketplaceId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/marketplace/${marketplaceId}/integration`,
    requestOptions
  ).then(handleResponse);
}

// helper functions

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // checking token expiry
      if (response.status === 401 && data.message.includes('Invalid JWT token')) {
        // redirecting to signin page
        history.push('/auth/signin');
        // removing local storage token
        localStorage.removeItem('user');
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}